import { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Skull } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReferralLanding() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "checking", name: "" });

  useEffect(() => {
    axios
      .get(`${API}/referral/${code}`)
      .then((r) => {
        localStorage.setItem("atrocity-ref", code);
        setState({ status: "accepted", name: r.data.referrer_name });
        setTimeout(() => navigate("/shop", { replace: true }), 3200);
      })
      .catch(() => setState({ status: "dead", name: "" }));
  }, [code, navigate]);

  return (
    <div data-testid="referral-landing" className="min-h-screen bg-void newsprint-grain flex items-center justify-center px-4">
      <div className="absolute inset-0 blood-vignette pointer-events-none" />
      {state.status === "checking" && (
        <p className="font-type text-paper/50">Reading the oath...</p>
      )}
      {state.status === "accepted" && (
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-lg"
        >
          <Skull size={56} className="mx-auto text-crimson crimson-glow mb-6" />
          <p className="font-marker text-bloodglow text-lg mb-4 -rotate-1">{state.name} swore you in</p>
          <h1 className="font-display text-3xl sm:text-4xl uppercase text-paper mb-5">
            BLOOD-OATH <span className="text-crimson">ACCEPTED</span>
          </h1>
          <p data-testid="referral-armed" className="font-type text-sm text-paper/70 leading-relaxed">
            Your first purchase bleeds <strong className="text-yell">10% lighter</strong> — the discount arms itself at
            checkout. Taking you to the crypt shop...
          </p>
        </motion.div>
      )}
      {state.status === "dead" && (
        <div className="text-center max-w-lg">
          <Skull size={56} className="mx-auto text-paper/30 mb-6" />
          <h1 className="font-display text-2xl sm:text-3xl uppercase text-paper mb-4">THAT OATH WAS NEVER SWORN</h1>
          <p className="font-type text-sm text-paper/60 mb-8">This referral link is dead or never existed.</p>
          <a
            href="/shop"
            data-testid="referral-dead-shop-link"
            className="font-impact uppercase tracking-wider text-xs bg-blooddeep text-white border-2 border-black px-6 py-3 ink-shadow-sm transition-colors duration-150 hover:bg-crimson"
          >
            Enter the shop anyway
          </a>
        </div>
      )}
    </div>
  );
}
